import { motion } from "framer-motion";
import { SERVICES } from "../../data";
import { Reveal, Overline } from "./Reveal";
import { WhatsAppButton, PreventivoButton } from "./CTAs";

export default function Services() {
  return (
    <section id="servizi" className="relative bg-white py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="max-w-3xl">
          <Reveal><Overline>I nostri servizi</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-display font-extrabold tracking-tight text-navy text-4xl sm:text-5xl">
              Un unico riferimento per la tua casa
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-4 text-ink/65 text-base sm:text-lg leading-relaxed">
              Dalla tinteggiatura al rifacimento del bagno, dalla muratura al cartongesso:
              eseguiamo piccoli lavori edili e manutenzioni in tutta Roma con precisione e rapidità.
            </p>
          </Reveal>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.name}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.5, delay: (i % 4) * 0.05 }}
                data-testid={`service-card-${i}`}
                className="group relative rounded-xl border border-gray-200 bg-white p-4 sm:p-5 hover:border-navy/30 hover:shadow-lg transition-[box-shadow,border-color,transform] duration-300 hover:-translate-y-1"
              >
                <span className="absolute left-0 top-4 h-0 w-0.5 bg-brand-orange group-hover:h-8 transition-[height] duration-300" />
                <Icon size={26} strokeWidth={1.6} className="text-navy group-hover:text-brand-orange transition-colors duration-300" />
                <p className="mt-3 text-sm sm:text-[15px] font-semibold text-ink leading-snug">{s.name}</p>
              </motion.div>
            );
          })}
        </div>

        <Reveal delay={0.1} className="mt-10 flex flex-col sm:flex-row gap-3">
          <WhatsAppButton testid="services-whatsapp" label="Chiedi su WhatsApp" />
          <PreventivoButton variant="outlineDark" testid="services-preventivo" label="Richiedi Preventivo" />
        </Reveal>
      </div>
    </section>
  );
}
